import { AxiosInstance, AxiosRequestConfig } from "axios";
import API from "./handlers/base.service";

/**
 * Utility wrapper for Axios instance
 * Allows easy extension of the api as a class for each endpoint.
 */
export abstract class ApiService {
  [k: string]: any;
  public service: AxiosInstance;
  public endpoint = "";

  /**
   * @param endpoint string un-slashed endpoint for all api methods.
   * @param apiService optional AxiosInstance to use for reqeusts.
   */
  constructor(endpoint = "", apiService: AxiosInstance = API) {
    this.endpoint = endpoint;
    this.service = apiService;
  }

  // Format endpoint with additional path string
  public endpointPath(path: string | number = "") {
    return `${this.endpoint}/${path}`;
  }

  public get(path: string, config?: AxiosRequestConfig) {
    return this.service.get(this.endpointPath(path), config);
  }

  // private inFlightRequests: Map<string, Promise<any>> = new Map();

  // public get(path: string, config?: AxiosRequestConfig) {
  //   const fullPath = this.endpointPath(path);

  //   if (this.inFlightRequests.has(fullPath)) {
  //     return this.inFlightRequests.get(fullPath)!;
  //   }
  //   const request = this.service.get(fullPath, config).finally(() => {
  //     this.inFlightRequests.delete(fullPath);
  //   });

  //   this.inFlightRequests.set(fullPath, request);

  //   return request;
  // }

  public patch(path: string, payload: any, config?: AxiosRequestConfig) {
    return this.service.patch(this.endpointPath(path), payload, config);
  }

  public post(path: string, payload: any, config?: AxiosRequestConfig) {
    return this.service.post(this.endpointPath(path), payload, config);
  }

  public put(path: string, payload: any, config?: AxiosRequestConfig) {
    return this.service.put(this.endpointPath(path), payload, config);
  }

  public delete(path: string) {
    return this.service.delete(this.endpointPath(path));
  }

  public list(params?: any, config: AxiosRequestConfig = {}) {
    if (params) {
      config.params = params;
    }

    return this.get("list", config);
  }

  public find(id: string | number, path = "", config?: AxiosRequestConfig) {
    return this.get(`${id}/${path}`, config);
  }

  public update(
    id: string | number,
    path = "",
    payload: any,
    config?: AxiosRequestConfig
  ) {
    return this.put(`${id}/${path}`, payload, config);
  }

  // call a custom request on the axios object.
  public request(config: AxiosRequestConfig) {
    return this.service.request(config);
  }
}
